import { AXON } from '@rsos/capstone/src/constants/capabilities';

const hasAxonCapability = (activeCapabilities = {}) => {
  if (typeof activeCapabilities === 'object') {
    return Object.keys(activeCapabilities).find(k => {
      return `${k}`.startsWith(AXON);
    });
  }
  return false;
};

export default hasAxonCapability;
